// Inventory Planner — module-local API client. All calls go to /api/ip/*, so the
// module can be pointed at a different backend by changing this one file. Thin
// wrapper over Recke's shared api helpers for the POC.
import axios from "axios";
import { API } from "../api";

export const IP = `${API}/ip`;

// Unlike the host's resilient GET helper, planner reads must not turn failures
// into "no data". Axios also honours AbortSignal for rapidly changing filters.
export const ipGet = async (path, opts = {}) => (await axios.get(`${IP}${path}`, { timeout: 45000, withCredentials: true, ...opts })).data;
export const ipPost = async (path, body = {}, opts = {}) => (await axios.post(`${IP}${path}`, body, { timeout: 120000, withCredentials: true, ...opts })).data;
export const ipError = (error, fallback = "Request failed. Please try again.") => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail?.message) return detail.message;
  const fields = error?.response?.data?.fields;
  return fields?.length ? fields.map(f => `${f.loc?.slice(1).join(" · ")}: ${f.msg}`).join("; ") : fallback;
};
export { API };
